"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InstrumentTableItem = function InstrumentTableItem(props) {
  var value = props.value,
    label = props.label,
    classModifiers = props.classModifiers,
    baseClasses = props.baseClasses;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('row', classModifiers)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('value', classModifiers)
  }, value), /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('title')
  }, label));
};
InstrumentTableItem.propTypes = {
  value: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  baseClasses: _propTypes["default"].func.isRequired,
  classModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
InstrumentTableItem.defaultProps = {
  classModifiers: []
};
var _default = exports["default"] = InstrumentTableItem;